module.exports = require("material-ui/IconButton");


//////////////////
// WEBPACK FOOTER
// external "material-ui/IconButton"
// module id = 219
// module chunks = 0